/**
 * Offline copy. This screen is what a field user or a resident sees when the phone has no signal,
 * so the wording is written for the person, not for a developer: no "this page is available when
 * the app cannot reach the network", just what happened and what to do next.
 */
export const offlineMessages = {
  fr: {
    title: 'Pas de connexion',
    body: 'Votre téléphone n’a pas de réseau pour l’instant. Déplacez-vous ou attendez un moment, puis réessayez.',
    retry: 'Réessayer',
    home: 'Retour à l’accueil'
  },
  en: {
    title: 'No connection',
    body: 'Your phone has no network right now. Move somewhere with signal or wait a moment, then try again.',
    retry: 'Try again',
    home: 'Back to home'
  },
  ar: {
    title: 'لا يوجد اتصال',
    body: 'هاتفك بلا شبكة حاليا. انتقل إلى مكان فيه شبكة أو انتظر قليلا ثم حاول مجددا.',
    retry: 'حاول مرة أخرى',
    home: 'العودة إلى الرئيسية'
  },
  ma: {
    title: 'ماكاينش النيت',
    body: 'التيليفون ديالك ماعندوش الشبكة دابا. سير لبلاصة فيها الشبكة ولا تسنى شوية ومن بعد عاود جرب.',
    retry: 'عاود جرب',
    home: 'رجع للرئيسية'
  }
}
